export const normalizeQuery = (query: Record<string, string | string[]>) => {
  const normalizedQuery = { ...query }
  if (normalizedQuery.q && typeof normalizedQuery.q === 'string') {
    normalizedQuery.q = normalizedQuery.q.toLowerCase()
  }
  return normalizedQuery
}
